/**
 * Copyright (c) 2017 CRF Box Oy. All Rights Reserved. Company Confidential.
 */

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { SIGNED_DOCUMENT, DECLINED_DOCUMENT } from './constants';
import DateHelper from '../../helper/date';

import {
  RESPONSES_SIGNED_DATE,
  RESPONSES_ABORTED_DATE,
  RESPONSES_DOCUMENT,
  RESPONSES_VERSION,
  RESPONSES_CHANGING_VERSION,
  RESPONSES_CHANGE_VERSION_ERROR
} from '../../const';

const VersionSelector = ({ selectedVersion, versions, selectNewDocumentVersion, error, setError }) => {
  return (
    <div className="versions-selector-wrapper">
      {error && (
        <i title={error} className="material-icons versions-selector-error">
          error_outline
        </i>
      )}
      <select
        className="versions-selector"
        value={selectedVersion}
        onClick={() => setError(null)}
        onChange={(event) => selectNewDocumentVersion(event.target.value)}
      >
        <option disabled>Select version</option>
        {versions.map((version) => (
          <option key={version} value={version}>
            {version}
          </option>
        ))}
      </select>
    </div>
  );
};

VersionSelector.propTypes = {
  selectedVersion: PropTypes.string,
  versions: PropTypes.array,
  selectNewDocumentVersion: PropTypes.func,
  error: PropTypes.string,
  setError: PropTypes.func
};

// getDocumentBanner :: (Object, String) -> (() -> JSX)
const getDocumentBanner = ({ participantId, document, documentType, changeDocumentVersion } = {}) =>
  function DocumentBanner() {
    const dateLabel =
      documentType === SIGNED_DOCUMENT
        ? RESPONSES_SIGNED_DATE
        : documentType === DECLINED_DOCUMENT
          ? RESPONSES_ABORTED_DATE
          : '';

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const dateValue = DateHelper.dateToDescription(new Date(document.signedDate));

    const selectNewDocumentVersion = (version) => {
      setLoading(true);
      setError(null);

      changeDocumentVersion(participantId, { documentGid: document.documentGid, documentType })(version).catch(() => {
        setLoading(false);
        setError(RESPONSES_CHANGE_VERSION_ERROR);
      });
    };

    return (
      <div className="document-banner">
        <div className="document-banner-field name">
          <label htmlFor="document-name" className="document-banner-label">
            {RESPONSES_DOCUMENT}:
          </label>
          <div name="document-name" className="document-banner-value" title={document.documentName}>
            {document.documentName}
          </div>
        </div>
        {loading ? (
          <div className="document-banner-field version">
            <span className="changing-version">{RESPONSES_CHANGING_VERSION}</span>
          </div>
        ) : (
          <div className="document-banner-field version">
            <label htmlFor="document-version" className="document-banner-label">
              {RESPONSES_VERSION}:
            </label>
            <div name="document-version" className="document-banner-value" title={document.documentVersion}>
              {document.versions.length > 0 ? (
                <VersionSelector
                  selectedVersion={document.documentVersion}
                  versions={document.versions}
                  selectNewDocumentVersion={selectNewDocumentVersion}
                  error={error}
                  setError={setError}
                />
              ) : (
                <span>{document.documentVersion}</span>
              )}
            </div>
          </div>
        )}
        <div className="document-banner-field date">
          <label htmlFor="document-signed-date" className="document-banner-label">
            {dateLabel}:
          </label>
          <div name="document-signed-date" className="document-banner-value" title={dateValue}>
            {dateValue}
          </div>
        </div>
      </div>
    );
  };

export default getDocumentBanner;
